import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconFileWordColor from './icon-file-word-color.vue';

const IconFileWordColor = Object.assign(_IconFileWordColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconFileWordColor.name, _IconFileWordColor);
  }
});

export default IconFileWordColor;
